import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {filter, map} from 'rxjs/operators';
import {TranslateModule} from '@ngx-translate/core';
import {NgxAurMatTableModule} from 'ngx-aur-mat-table';

import {AuthUserService} from '@common-module/app-services/auth-user.service';
import {
  IconButtonOrangeComponent,
} from '@common-module/buttons/icon/styled/icon-button-orange/icon-button-orange.component';
import {MaterialModule} from '@common-module/material.module';
import {Notification} from '@common-module/modelinterfaces/notification.model';
import {NotificationWithNew} from '@common-module/modelinterfaces/notification-with-new.model';
import {TimestampTimezoneConvertPipe} from '@common-module/pipes/timestamp-timezone-convert.pipe';

import {NotificationManagerService} from '../../../shared/services/notification-manager.service';
import {createNotificationTableConfig} from './notification-table.config';

@Component({
  selector: 'app-notification-table',
  templateUrl: './notification-table.component.html',
  styleUrls: ['./notification-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IconButtonOrangeComponent,
    MaterialModule,
    NgxAurMatTableModule,
    TimestampTimezoneConvertPipe,
    TranslateModule,
  ],
})
export class NotificationTableComponent {
  private readonly authUserService = inject(AuthUserService);
  private readonly notificationManagerService = inject(NotificationManagerService);

  protected readonly notifications = toSignal(
    this.notificationManagerService.lastNotifications$,
    {initialValue: []},
  );
  protected readonly loading = toSignal(
    this.notificationManagerService.loadingNotices$,
    {initialValue: false},
  );
  protected readonly readNotificationId = toSignal(
    this.notificationManagerService.readNotificationId$,
  );
  protected readonly timeZone = toSignal(
    this.authUserService.currentUser$.pipe(
      filter(Boolean),
      map(user => user.getUserTimeZone()),
    ),
    {initialValue: 'browser'},
  );
  protected readonly tableConfig = computed(() => createNotificationTableConfig());

  protected openNotificationDetails(notification: NotificationWithNew | undefined): void {

    if (notification) {
      this.notificationManagerService.openNotificationDetails(notification.notification.id);
    }
  }

  protected readNotification(notificationId: number, event: Event): void {
    this.notificationManagerService.readNotification([notificationId], event);
  }

  protected asNotification(value: NotificationWithNew): Notification {
    return value.notification;
  }
}
